<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['field_name', 'department', 'com_name', 'rank', 'writer_name', 'date', 'updated_at']"
      :typeslabel="{
        date: '최초 작성일',
        updated_at: '최종 수정일',
      }"
    />

    <div class="mt-6">
      <vs-row class="flex justify-between items-center">
        <h5 style="align-self: end;"><i class="dot"></i> 보호구 수불대장</h5>
        <div v-if="!isPrint" class="ml-auto">
          <vs-button color="secondary" @click="addRow"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow" > 선택삭제 </vs-button>
        </div>
      </vs-row>

      <table class="table-monthly" style="margin-top: 14px;">
      <thead>
        <tr>
          <th class="type-column">종류</th>
          <th>구분</th>
          <th>이월</th>
          <th>1월</th>
          <th>2월</th>
          <th>3월</th>
          <th>4월</th>
          <th>5월</th>
          <th>6월</th>
          <th>7월</th>
          <th>8월</th>
          <th>9월</th>
          <th>10월</th>
          <th>11월</th>
          <th>12월</th>
          <th>총계</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in form.수불대장">
          <tr v-for="(type, typeIndex) in item.구분"
              :key="`row-${index}-${typeIndex}`">
            <template v-if="typeIndex === 0">
              <td v-if="['안전모', '안전화', '귀마개', '방진마스크', '방독마스크', '조끼', '작업복'].includes(item.id)"
                  :rowspan="3" class="type-column">{{ item.품목 }}</td>
              <td v-else :rowspan="3" class="type-column">
                <div class="flex gap-2 items-center" :style="isPrint? 'justify-self: center' : ''">
                  <vs-checkbox v-if="!isPrint" v-model="item.selected" />
                  <p v-if="isPrint">{{ item.품목 }}</p>
                  <ml-input v-else v-model="item.품목" />
                </div>
              </td>
            </template>
            <td>{{ type }}</td>
            <td v-for="month in months"
                :key="`cell-${index}-${typeIndex}-${month}`">
              <template v-if="isPrint">
                <p>{{ getValue(item, type, month) }}</p>
              </template>
              <template v-else>
                <ml-input
                  class="w-full"
                  type="number"
                  :value="getValue(item, type, month)"
                  @input="updateValue(item, type, month, $event)"
                  min="0"
                  step="1"
                />
              </template>
            </td>
            <td>
              <template v-if="isPrint">
                <p>{{ getTotal(item, type) }}</p>
              </template>
              <template v-else>
                <ml-input
                  class="w-full"
                  type="number"
                  :value="getTotal(item, type)"
                  readonly
                />
              </template>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>



  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        fileList: [],
        수불대장: [
          { id: '안전모', 품목: '안전모', 구분: ['반입', '지급', '재고'] },
          { id: '안전화', 품목: '안전화', 구분: ['반입', '지급', '재고'] },
          { id: '귀마개', 품목: '귀마개', 구분: ['반입', '지급', '재고'] },
          { id: '방진마스크', 품목: '방진마스크', 구분: ['반입', '지급', '재고'] },
          { id: '방독마스크', 품목: '방독마스크', 구분: ['반입', '지급', '재고'] },
          { id: '조끼', 품목: '조끼', 구분: ['반입', '지급', '재고'] },
          { id: '작업복', 품목: '작업복', 구분: ['반입', '지급', '재고'] },
        ],
        월별데이터: {}
      },
      months: ['이월', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addRow() {
      this.form.수불대장.push({
        id: Math.random().toString(36).substr(2, 9),
        품목: '',
        구분: ['반입', '지급', '재고'],
        selected: false,
      });
      this.allCheck = false;
    },
    deleteRow() {
      const selectedRow = this.form.수불대장.filter((row) => row.selected);
      if (selectedRow.length === 0) {
        return;
      }

      this.form.수불대장 = this.form.수불대장.filter((row) => !row.selected);
      this.allCheck = false;
    },
    updateValue(item, type, month, value) {
      const numValue = Number(value);
      const validValue = numValue < 0 ? 0 : numValue;

      if (!this.form.월별데이터[item.품목]) {
        this.$set(this.form.월별데이터, item.품목, {});
      }
      if (!this.form.월별데이터[item.품목][type]) {
        this.$set(this.form.월별데이터[item.품목], type, {});
      }
      this.$set(this.form.월별데이터[item.품목][type], month, validValue);
    },
    getValue(item, type, month) {
      const itemData = this.form.월별데이터[item.품목] || {};
      const typeData = itemData[type] || {};
      return typeData[month] || 0;
    },
    getTotal(item, type) {
      const totals = this.totalCalculations;
      const itemTotals = totals[item.품목] || {};
      return itemTotals[type] || 0;
    }
  },
  computed: {
    totalCalculations() {
      const totals = {};

      this.form.수불대장.forEach(item => {
        if (!totals[item.품목]) totals[item.품목] = {};

        item.구분.forEach(type => {
          if (!totals[item.품목][type]) totals[item.품목][type] = 0;

          let sum = 0;
          this.months.forEach(month => {
            const monthData = this.form.월별데이터[item.품목] || {};
            const typeData = monthData[type] || {};
            const value = Number(typeData[month] || 0);
            sum += value;
          });
          totals[item.품목][type] = sum;
        });
      });

      return totals;
    }
  }
};
</script>

<style lang="scss" scoped>
.table-monthly {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th, td {
    border: 1px solid #cdcdcd;
    padding: 8px;
    text-align: center;
    font-size: 14px;
  }

  th {
    background: #f9f9f9;
    font-weight: 500;
  }

  .type-column {
    width: 140px;
  }

  tbody tr {
    background: #fff;
  }

  td {
    white-space: pre-line;
    vertical-align: middle;
  }

  .w-full {
    width: 100%;
  }

  :deep(.ml-input) {
    &[readonly] {
      background-color: #f5f5f5;
      cursor: not-allowed;
    }
  }
}
</style>
